import { render } from "./TasksList.vue?vue&type=template&id=33527d81&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=33527d81&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33527d81"

export default script